import React, { useState, useEffect } from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const StickyIcons = () => {
  const [toggle, setToggle] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleLinkClick = () => {
    setToggle(false);
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth < 720);
  };

  useEffect(() => {
    // Handle resize event
    handleResize();
    window.addEventListener('resize', handleResize);

    // Create hidden input for XIRCLS details
    const input = document.createElement('input');
    input.type = 'hidden';
    input.id = 'xircls_unique_details';
    input.value = 'bWF5YS5lZHUuaW4=';
    document.body.appendChild(input);

    // Load WhatsApp widget script
    const script = document.createElement('script');
    script.src = 'https://apps.xircls.com/static/whatsapp/widget.js';
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);

    // Cleanup function
    return () => {
      window.removeEventListener('resize', handleResize);
      // Remove script and input when component unmounts
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      if (input.parentNode) {
        input.parentNode.removeChild(input);
      }
    };
  }, []);

  return (
    <div className="fixed right-4 top-1/2 transform -translate-y-1/2 flex flex-col gap-4">
      {/* Phone Icon */}
      <a
        href="tel:+91-7351441144"
        className="bg-gradient-to-r from-blue-500 to-blue-700 w-[50px] h-[50px] flex items-center justify-center rounded-full text-white shadow-lg hover:shadow-xl transition transform hover:scale-105"
        aria-label="Call Us"
      >
        <FaPhoneAlt size={28} />
      </a>

      {/* WhatsApp Icon - XIRCLS Widget */}
      <button
        onClick={() => {
          if (window.XIRCLS && window.XIRCLS.openWhatsAppChat) {
            window.XIRCLS.openWhatsAppChat();
          }
        }}
       
      >
        {/* <FaWhatsapp size={28} /> */}
      </button>

      {/* Apply Now Link */}
      <Link
        to="https://admission.maya.edu.in/"
        onClick={() => {
          window.scrollTo(0, 0);
          handleLinkClick();
        }}
        className="bg-gradient-to-r from-red-500 to-red-700 w-[50px] h-[50px] flex items-center justify-center rounded-full text-white shadow-lg hover:shadow-xl transition transform hover:scale-105"
        aria-label="Apply Now"
      >
        <span className="text-xs">Apply</span>
      </Link>
    </div>
  );
};

export default StickyIcons;